import { render, staticRenderFns } from "./brokerage-catalog-share-list.vue?vue&type=template&id=1e6d9934&"
import script from "./brokerage-catalog-share-list.vue?vue&type=script&lang=js&"
export * from "./brokerage-catalog-share-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports